import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';

// TODO: delete together with ComponentLegacy and Layout once the Mantine layout fully replaces the legacy one.
import BannersLayout from '@pages/banners-layout/ui/BannersLayout';
import Layout from '@pages/layout/ui/Layout';
import LayoutMantine from '@pages/layout/ui/LayoutMantine';

const ComponentLegacy = () => (
  <div>
    <Layout />
    <div className='container__wrap'>
      <Outlet />
      <BannersLayout />
    </div>
  </div>
);

const ComponentMantine = () => (
  <LayoutMantine>
    <Outlet />
  </LayoutMantine>
);

export const Route = createFileRoute('/_auth/_layout')({
  component:
    import.meta.env.MODE_FEATURE_FLAG_REDESIGN_MANTINE === 'on'
      ? ComponentMantine
      : ComponentLegacy,
});
